import React from 'react';
import Firesafety2024  from 'views/Firesafety2024';

const LifeSkillPage = () => {
  return <Firesafety2024/>;
};

export default LifeSkillPage;
